import { render, staticRenderFns } from "./addCCCK.vue?vue&type=template&id=1f5a97b5&scoped=true&lang=html&"
import script from "./addCCCK.vue?vue&type=script&lang=js&"
export * from "./addCCCK.vue?vue&type=script&lang=js&"
import style0 from "./addCCCK.vue?vue&type=style&index=0&id=1f5a97b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a97b5",
  null
  
)

export default component.exports